<template>
  <div id="app">
    <!-- <Header></Header> -->
    <router-view/>
    <!-- <Footer></Footer> -->
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
import { changeLanguage } from '@/assets/i18n/index'
export default {
  name: 'App',
  mounted(){
  	let lang = localStorage.getItem('vipLang');
  	changeLanguage(lang);
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue